import backgroundImage from './images/LP-Are_Your_Windows_Fit_For_Indows-image_01.jpg';
export const load = () => ({
	title: 'Are Your Windows Fit For Indows?',
	showTitle: true,
	hideHeaderButton: false,
	backgroundImage,
});
